var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"fr-all-in-one-container"},[(_vm.stages.idmUserDetails)?_c('idmUserDetails',{attrs:{"inline":true,"selfServiceDetails":_vm.selfServiceDetails}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }